// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--OR9rg","arrow":"a10a3f92e9--arrow--z4QhZ","arrow__expanded":"a10a3f92e9--arrow__expanded--wbaix"};